import { FormProvider, useForm } from 'react-hook-form';
import React, { FC } from 'react';
import { Box, Button, Grid, Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import styled from '../../../../../styled';

import { AboutFormData } from './types';
import { Info } from './general/info';
import { Errors } from './errors';
import { HeatingForm } from './heating';
import { Ventilation } from './ventilation';

const ButtonWrapper = styled(Box)`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

interface Props {
  defaultValues: AboutFormData;
  onSubmit: (values: AboutFormData) => void;
}

export const SoknadAboutForm: FC<Props> = ({ defaultValues, onSubmit }) => {
  const { t } = useTranslation();
  const methods = useForm<AboutFormData>({
    defaultValues,
    mode: 'onBlur'
  });

  const errors = methods.formState.errors;

  const submitCaption = !defaultValues.registreringId
    ? t('register.actions.startDetailing')
    : t('register.actions.next');

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
        <Box display="flex" flexDirection="column" gap={3}>
          <Typography variant="h2">{t('register.general.aboutBuilding.heading')}</Typography>
          <Typography gutterBottom>{t('register.general.aboutBuilding.description')}</Typography>

          <Info control={methods.control} setValue={methods.setValue} />
          <HeatingForm control={methods.control} />
          <Ventilation control={methods.control} />

          <Grid item xs={12} m={2}>
            <Typography variant="h2" gutterBottom>
              {t('register.basicInformation.buildingDetailsSoknad.title')}
            </Typography>

            <Typography gutterBottom className="text-preline">
              {t('register.basicInformation.buildingDetailsSoknad.description')}
            </Typography>
          </Grid>

          <Errors errors={errors} />
          <ButtonWrapper my={3}>
            <Button type="submit">{submitCaption}</Button>
          </ButtonWrapper>
        </Box>
      </form>
    </FormProvider>
  );
};
